'use client'

import { Button } from '@cocoonspace/ui/components/button'
import {
	Sheet,
	SheetClose,
	SheetContent,
	SheetHeader,
	SheetTitle,
	SheetTrigger,
} from '@cocoonspace/ui/components/sheet'
import { useLingui } from '@lingui/react/macro'
import { MenuIcon } from 'lucide-react'

import { LocalizedLink as Link } from '~/components/localized-link'
import { useAuth } from '~/providers/auth-provider'
import { LangSelector } from './lang-selector'
import { SolutionsLinks } from './solutions-popover'

export const GuestMobileMenu = () => {
	const { t } = useLingui()
	const { openLogin, openRegister } = useAuth()

	return (
		<Sheet>
			<SheetTrigger asChild>
				<Button
					icon
					variant='text'
					aria-label={t`Ouvrir le menu`}
				>
					<MenuIcon aria-hidden />
				</Button>
			</SheetTrigger>
			<SheetContent
				className='flex flex-col gap-8 overflow-y-auto'
				aria-describedby={undefined}
			>
				<SheetHeader>
					<SheetTitle>{t`Navigation principale`}</SheetTitle>
				</SheetHeader>
				<div className='flex flex-col gap-4'>
					<SheetClose asChild>
						<Button asChild>
							<Link href='/paris'>{t`Trouver un Cocoon`}</Link>
						</Button>
					</SheetClose>
					<p className='font-bold'>{t`Nos solutions`}</p>
					<SolutionsLinks closeOnNavigate />
				</div>
				<div className='flex flex-col items-start gap-4 border-t pt-6'>
					<SheetClose asChild>
						<Button
							variant='link'
							onClick={() => openLogin()}
						>{t`Se connecter`}</Button>
					</SheetClose>
					<SheetClose asChild>
						<Button
							variant='textPrimary'
							onClick={() => openRegister()}
						>{t`S'inscrire`}</Button>
					</SheetClose>
				</div>
				<div className='mt-auto flex flex-col items-start gap-4 border-t pt-6'>
					<SheetClose asChild>
						<Button
							asChild
							variant='link'
						>
							<Link
								href='https://support.cocoon-space.com'
								target='_blank'
								rel='noopener noreferrer'
							>{t`Aide`}</Link>
						</Button>
					</SheetClose>
					<LangSelector />
				</div>
			</SheetContent>
		</Sheet>
	)
}
